module.exports = __webpack_public_path__ + "img/arrow-expand.5710bd24.svg";